var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardingParentSolution(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 340,
    viewBox: "0 0 500 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Give reward for a good behavior"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 130.373,
    y: 1,
    width: 298.711,
    height: 188.395,
    stroke: "#D6DCFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.41 58.2607C266.149 56.9045 264.419 56.1576 262.538 56.1576C261.132 56.1576 259.845 56.5984 258.711 57.4677C258.139 57.9065 257.621 58.4433 257.164 59.0699C256.707 58.4435 256.189 57.9065 255.617 57.4677C254.483 56.5984 253.196 56.1576 251.79 56.1576C249.909 56.1576 248.179 56.9045 246.918 58.2607C245.673 59.601 244.986 61.432 244.986 63.4168C244.986 65.4596 245.754 67.3296 247.402 69.3018C248.876 71.066 250.995 72.8569 253.449 74.9306C254.287 75.6388 255.236 76.4416 256.222 77.2967C256.483 77.523 256.817 77.6476 257.164 77.6476C257.511 77.6476 257.845 77.523 258.105 77.2971C259.091 76.4418 260.042 75.6387 260.88 74.9301C263.333 72.8567 265.452 71.066 266.926 69.3016C268.574 67.3296 269.342 65.4596 269.342 63.4166C269.342 61.432 268.655 59.601 267.41 58.2607Z",
    fill: "#FF9B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.803 37.7127C314.802 36.673 313.428 36.1003 311.934 36.1003C310.818 36.1003 309.795 36.4383 308.895 37.1047C308.441 37.4411 308.029 37.8527 307.667 38.3331C307.304 37.8529 306.892 37.4411 306.438 37.1047C305.538 36.4383 304.515 36.1003 303.399 36.1003C301.905 36.1003 300.531 36.673 299.53 37.7127C298.541 38.7403 297.996 40.1441 297.996 41.6657C297.996 43.2319 298.606 44.6655 299.914 46.1776C301.085 47.5301 302.768 48.9031 304.716 50.493C305.382 51.036 306.136 51.6514 306.919 52.307C307.126 52.4805 307.391 52.576 307.667 52.576C307.942 52.576 308.207 52.4805 308.414 52.3073C309.197 51.6516 309.952 51.0358 310.617 50.4926C312.566 48.903 314.248 47.5301 315.419 46.1774C316.728 44.6655 317.337 43.2319 317.337 41.6656C317.337 40.1441 316.792 38.7403 315.803 37.7127Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 94",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.274 127.246C497.102 128.469 489.006 149.569 475.432 161.029C461.858 172.49 462.947 176.39 458.616 179.813C454.286 183.236 448.423 182.378 448.423 182.378C448.423 182.378 465.446 126.022 481.274 127.246Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 94 Copy 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.274 171.079C497.102 172.302 489.006 193.402 475.432 204.863C461.858 216.323 462.947 220.223 458.616 223.646C454.286 227.069 448.423 226.211 448.423 226.211C448.423 226.211 465.446 169.856 481.274 171.079Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 96 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.083 276.361C438.985 267.621 422.878 227.655 408.607 213.923C394.336 200.19 378.678 204.427 386.168 223.011C393.658 241.596 404.212 238.628 410.816 255.015C417.421 271.402 447.181 285.102 443.083 276.361Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 94 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.933 163.901C378.192 165.505 388.801 193.171 406.588 208.197C424.374 223.223 417.327 228.492 429.055 236.188C440.783 243.884 441.978 236.188 441.978 236.188C441.978 236.188 419.673 162.297 398.933 163.901Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 96",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.237 183.2C435.701 173.524 435.701 130.271 427.574 112.117C419.447 93.9634 403.295 92.0043 403.295 112.117C403.295 132.23 414.225 133.446 414.225 151.18C414.225 168.915 436.772 192.876 436.237 183.2Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 101",
    d: "M450.548 305.427C451.549 219.055 421.398 110.983 414.039 99.195",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 102",
    d: "M440.544 202.67C440.544 202.67 450.681 167.472 480.658 133.687",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 103",
    d: "M445.558 234.288C448.303 219.654 480.658 173.209 480.658 173.209",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 94 Copy 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.954 199.826C508.238 201.24 498.886 225.629 483.205 238.875C467.525 252.121 468.783 256.629 463.78 260.586C458.778 264.542 452.006 263.551 452.006 263.551C452.006 263.551 471.67 198.412 489.954 199.826Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 103 Copy",
    d: "M449.856 273.091C452.994 256.219 489.971 202.67 489.971 202.67",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 104",
    d: "M448.422 259.438C445.297 235.953 434.507 233.422 428.43 217.545C422.352 201.668 419.295 187.505 397.562 166.023",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 105",
    d: "M450.572 291.055C429.441 251.347 402.415 225.613 394.698 218.479",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.538971 309.616C4.93678 309.497 12.4274 309.231 25.5797 308.767C33.0656 308.503 39.0557 308.315 44.8562 308.172C64.6093 307.685 78.8154 307.835 87.4403 308.851C92.2673 309.419 95.1357 310.284 95.6185 311.178C95.9725 311.834 94.3337 313.253 90.0486 315.128C69.1824 313.746 48.9802 315.493 36.3018 319.752C18.3216 317.588 4.83785 314.62 1.45248 310.835C1.0709 310.409 0.767627 310.002 0.538971 309.616ZM0.0030898 308.03C-0.307881 301.913 22.9053 301.913 46.4782 301.913H128.423C127.349 303.213 128.266 305.485 130.856 308.623C138.163 317.474 157.274 324.752 189.998 333.089C193.38 333.95 196.85 334.811 200.92 335.802C173.677 332.314 157.876 327.37 139.053 325.226C133.193 322.965 128.051 321.352 122.478 319.982C113.155 317.689 103.172 316.172 93.259 315.365C96.5885 313.603 97.8894 312.023 97.0234 310.419C96.1727 308.844 93.057 307.904 87.6276 307.265C78.9024 306.238 64.6464 306.087 44.8176 306.576C39.0105 306.719 33.0151 306.907 25.524 307.172C11.7886 307.656 4.26753 307.921 0.0030898 308.03ZM138.463 301.913H206.801C204.54 304.808 203.672 308.018 204.557 311.058C205.814 315.376 213.889 317.771 231.481 320.639C233.02 320.89 240.107 322.012 241.942 322.314C250.3 323.692 254.751 324.746 256.579 325.957C257.342 326.463 257.386 326.701 256.844 327.237C255.969 328.103 253.842 329.142 250.403 330.319C240.634 333.66 222.032 330.015 193.723 320.632C189.721 319.305 185.525 317.867 180.804 316.21C176.659 314.756 161.203 309.236 157.746 308.025C149.633 305.185 144.023 303.367 139.63 302.211C139.23 302.106 138.841 302.006 138.463 301.913V301.913ZM208.893 301.913H235.026C243.066 301.913 254.205 301.913 267.324 301.932C276.522 306.664 278.88 312.479 276.354 319.931C275.292 323.064 273.583 326.131 270.53 330.779C267.475 335.429 265.882 337.881 264.976 339.59C244.217 339.483 227.538 338.564 213.613 337.223C209.935 336.337 205.506 335.271 204.604 335.053C199.044 333.709 194.647 332.626 190.392 331.542C158.066 323.306 139.078 316.075 132.086 307.606C129.569 304.557 129.163 303.089 130.007 302.685C131.201 302.113 134.327 302.466 139.225 303.755C143.566 304.897 149.144 306.705 157.22 309.532C160.671 310.74 176.126 316.261 180.277 317.717C185.006 319.376 189.211 320.818 193.222 322.147C221.911 331.656 240.676 335.333 250.92 331.829C254.575 330.579 256.87 329.457 257.967 328.372C259.279 327.074 259.019 325.658 257.462 324.626C255.356 323.231 250.858 322.166 242.203 320.739C240.362 320.436 233.273 319.314 231.739 319.064C215.217 316.37 207.062 313.951 206.091 310.612C205.268 307.785 206.324 304.681 208.893 301.913V301.913ZM270.559 301.937C281.256 301.955 293.151 301.987 305.681 302.041C315.81 308.229 316.633 319.052 309.11 330.625C307.123 333.682 304.725 336.505 302.053 339.003C300.729 339.05 299.4 339.093 298.067 339.134C286.714 339.483 276.334 339.625 266.803 339.598C267.726 337.977 269.243 335.646 271.865 331.655C274.988 326.901 276.749 323.741 277.866 320.444C280.403 312.96 278.387 306.83 270.559 301.937ZM308.536 302.054C320.694 302.11 333.401 302.188 346.152 302.297C348.06 304.525 347.966 306.985 345.734 309.739C341.493 314.972 339.108 318.452 338.177 320.839C337.116 323.564 337.901 325.306 340.442 325.812C342.387 326.2 345.386 325.942 350.626 325.058C352.368 324.764 363.867 322.643 367.847 321.971C368.715 321.824 369.572 321.683 370.423 321.545C379.165 320.13 390.304 316.57 416.655 307.311L417.035 307.178C420.769 305.866 424.158 304.68 427.25 303.606C440.871 303.99 452.616 304.462 461.349 305.04C449.254 313.811 427.557 321.29 401.055 326.364C372.495 331.831 343.073 333.436 329.939 330.297C320.696 328.089 315.732 329.973 315.732 336.094C315.732 336.81 315.803 337.584 315.945 338.417C312.151 338.605 308.313 338.772 304.434 338.917C306.684 336.652 308.716 334.159 310.447 331.495C317.916 320.005 317.553 308.909 308.536 302.054ZM348.138 302.315C374.399 302.546 400.737 302.91 422.75 303.484C420.782 304.172 418.705 304.9 416.508 305.672L416.128 305.805C389.899 315.021 378.774 318.577 370.171 319.969C369.316 320.107 368.455 320.25 367.584 320.397C363.587 321.071 352.089 323.193 350.362 323.484C345.326 324.333 342.438 324.582 340.756 324.247C339.251 323.947 338.946 323.269 339.667 321.419C340.518 319.235 342.837 315.851 346.976 310.744C349.449 307.694 349.736 304.848 348.138 302.315ZM463.772 305.209C469.061 305.598 473.034 306.032 475.381 306.518C496.376 310.865 424.68 332.843 317.549 338.336C317.402 337.523 317.328 336.776 317.328 336.094C317.328 331.308 321.179 329.846 329.568 331.85C342.974 335.054 372.591 333.438 401.354 327.932C429.158 322.609 451.723 314.67 463.772 305.209ZM132.723 324.627C128.821 324.334 124.737 324.169 120.359 324.166C106.426 324.158 90.9643 323.764 75.9071 322.98C82.5096 320.134 89.4616 317.122 90.2706 316.772C101.037 317.493 111.975 319.043 122.096 321.532C125.711 322.421 129.146 323.414 132.723 324.627ZM72.324 322.785C60.969 322.144 49.9347 321.278 40.0626 320.186C51.7795 317.038 68.8657 315.664 86.7334 316.564C83.264 318.066 77.3709 320.614 72.324 322.785Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 274",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.399 155.245C308.523 157.739 323.914 162.154 335.495 164.15C347.076 166.147 342.167 139.842 342.167 139.842H333.066L331.484 155.245C331.484 155.245 306.276 152.751 307.399 155.245Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 249",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.05 267.315C350.05 267.315 358.646 295.902 357.436 299.14C356.225 302.378 344.933 306.946 342.468 307.933C340.003 308.919 337.391 308.171 338.928 310.352C340.464 312.534 344.162 311.636 347.106 311.636C350.05 311.636 358.911 310.728 362.678 311.636C366.444 312.544 370.666 311.636 370.666 307.933C370.666 304.229 367.521 300.127 366.444 292.724C365.368 285.322 365.81 271.217 364.244 265.703C362.678 260.189 350.05 267.315 350.05 267.315Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 248 Copy",
    d: "M364.6 300.271C364.6 300.271 364.847 303.265 362.73 304.485",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 53 Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 249_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.404 267.156C395.404 267.156 409.756 293.331 409.245 296.75C408.733 300.169 398.639 306.985 396.432 308.463C394.226 309.94 391.516 309.751 393.472 311.566C395.428 313.38 398.859 311.733 401.739 311.121C404.619 310.509 413.097 307.779 416.97 307.883C420.843 307.988 424.784 306.222 424.014 302.6C423.244 298.977 419.315 295.618 416.723 288.602C414.131 281.585 411.631 267.696 408.952 262.628C406.274 257.561 395.404 267.156 395.404 267.156Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 248 Copy_2",
    d: "M416.487 296.367C416.487 296.367 417.351 299.244 415.534 300.878",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path 258",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.765 169.391C334.765 169.391 333.94 192.549 336.001 210.924C338.062 229.299 347.854 293.317 347.854 293.317H374.055L362.75 217.277L362.422 202.357C362.422 202.357 373.509 222.064 375.273 227.186C377.037 232.308 402.269 293.317 402.269 293.317H427.324C427.324 293.317 395.422 205.765 392.651 198.663C391.762 181.098 383.893 169.391 383.893 169.391H334.765Z",
    fill: "#1D70D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 272",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.247 101.91C354.247 101.91 340.536 103.8 336.619 110.091C332.701 116.382 325.861 138.69 325.861 138.69L336.619 139.952C336.619 139.952 333.753 167.056 335.186 169.383C336.619 171.71 378.152 171.565 382.943 171.565C387.735 171.565 385.445 138.69 385.445 138.69H398.975C398.975 138.69 394.866 116.382 390.871 110.091C386.876 103.8 366.673 101.91 366.673 101.91H354.247Z",
    fill: "#0ACC94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 271",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.914 97.5365C369.021 97.5365 375.587 96.1444 381.805 102.679C388.024 109.215 367.84 132.111 344.341 129.422C320.842 126.734 318.69 119.244 303.354 120.545L308.934 113.814C308.934 113.814 318.831 111.932 330.934 117.893C343.036 123.854 362.781 125.695 374.154 113.01C385.526 100.326 362.914 100.363 362.914 100.363C362.914 100.363 353.561 99.5363 345.835 102.679C338.109 105.823 322.463 113.842 304.002 111.649L297.098 108.793C297.098 108.793 310.18 110.286 316.629 108.793C323.078 107.3 337.421 99.5892 345.835 98.7121C354.249 97.8351 356.806 97.5365 362.914 97.5365Z",
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 282"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.903 129.641L222.447 138.589C222.447 138.589 272.719 113.517 279.529 109.26C286.338 105.004 302.291 107.142 302.291 109.26C302.291 111.379 309.372 114.95 307.35 117.815C305.327 120.68 283.572 119.33 281.104 121.438C278.636 123.546 241.643 156.81 228.273 158.76C214.903 160.709 199.238 142.621 199.238 142.621",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.903 129.641L222.447 138.589C222.447 138.589 272.719 113.517 279.529 109.26C286.338 105.004 302.291 107.142 302.291 109.26C302.291 111.379 309.372 114.95 307.35 117.815C305.327 120.68 283.572 119.33 281.104 121.438C278.636 123.546 241.643 156.81 228.273 158.76C214.903 160.709 199.238 142.621 199.238 142.621",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.428 123.546C307.736 123.546 314.471 120.339 314.471 116.382C314.471 112.426 307.736 109.219 299.428 109.219C291.12 109.219 284.385 112.426 284.385 116.382C284.385 120.339 291.12 123.546 299.428 123.546Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.428 120.68C307.736 120.68 314.471 117.473 314.471 113.517C314.471 109.561 307.736 106.354 299.428 106.354C291.12 106.354 284.385 109.561 284.385 113.517C284.385 117.473 291.12 120.68 299.428 120.68Z",
    fill: "#FFDC84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.069 117.815C305.597 117.815 310.889 115.891 310.889 113.517C310.889 111.143 305.597 109.219 299.069 109.219C292.542 109.219 287.25 111.143 287.25 113.517C287.25 115.891 292.542 117.815 299.069 117.815Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path 266"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.631 75.9482C376.631 75.9482 382.58 74.6401 380.597 80.8277C378.614 87.0152 374.56 83.6238 374.56 83.6238L369.718 91.0655C369.718 91.0655 368.218 101.55 370.617 103.323C369.071 107.595 364.953 112.742 357.98 111.446C351.006 110.149 350.916 104.54 350.916 104.54C350.916 104.54 354.858 103.287 354.858 95.9577",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.631 75.9482C376.631 75.9482 382.58 74.6401 380.597 80.8277C378.614 87.0152 374.56 83.6238 374.56 83.6238L369.718 91.0655C369.718 91.0655 368.218 101.55 370.617 103.323C369.071 107.595 364.953 112.742 357.98 111.446C351.006 110.149 350.916 104.54 350.916 104.54C350.916 104.54 354.858 103.287 354.858 95.9577",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 268",
    d: "M375.271 80.847L378.137 79.4144",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 246"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.703 75.8327V63.6551L366.674 56.1577L343.035 63.6551C343.035 63.6551 343.035 72.7781 343.035 80.5005C343.035 88.2228 344.463 94.6216 352.547 95.6821C360.631 96.7425 366.674 92.3963 366.674 92.3963",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.703 75.8327V63.6551L366.674 56.1577L343.035 63.6551C343.035 63.6551 343.035 72.7781 343.035 80.5005C343.035 88.2228 344.463 94.6216 352.547 95.6821C360.631 96.7425 366.674 92.3963 366.674 92.3963",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 269",
    d: "M348.187 78.775C348.187 78.775 348.897 79.6029 348.187 80.847C347.477 82.091 346.211 82.7685 348.364 83.5173",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 270",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.334 86.4329C349.334 86.4329 356.655 86.0858 359.168 85.6561C359.168 85.6561 358.7 90.2994 354.017 90.646C349.334 90.9926 349.334 86.4329 349.334 86.4329Z",
    fill: "#D6DCFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 267",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.912 51.9727C374.912 51.9727 382.521 54.4494 381.624 62.6037C380.727 70.7579 379.051 75.8291 379.051 75.8291L376.367 75.9435C376.367 75.9435 375.379 80.113 373.901 77.9711C372.422 75.8291 372.751 71.1455 372.422 68.0015C369.359 68.4699 367.113 66.7103 365.72 62.6037C363.028 66.0613 355.783 68.2797 355.783 66.3337C352.038 67.8521 342.766 69.9063 342.766 63.7458C338.971 64.0327 336.467 58.6733 341.788 54.1401C347.109 49.6069 359.147 44.6884 366.524 45.9465C373.901 47.2045 374.912 51.9727 374.912 51.9727Z",
    fill: "#1D70D3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 302.293,
    y: 134.291,
    width: 33.6676,
    height: 21.49,
    fill: "#1D70D3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 31",
    x: 323.783,
    y: 134.291,
    width: 33.6676,
    height: 21.49,
    fill: "#D6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 286",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.363 298.62C108.363 298.62 125.454 303.271 125.454 309.391H98.296C98.296 309.391 83.2143 267.431 82.4992 263.699C81.7841 259.968 86.9276 256.636 89.2155 262.012C91.5033 267.388 108.363 298.62 108.363 298.62Z",
    fill: "#FF9B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 285",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.29 274.248H112.693L108.36 298.619L101.846 304.485L87.9141 263.298C87.9141 263.298 90.5892 255.919 101.846 255.919C113.102 255.919 141.638 258.886 141.638 258.886L138.29 274.248Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 288",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.033 302.378C158.033 302.378 151.917 304.961 155.86 310.79H220.542C220.542 310.79 218.956 300.271 201.546 300.271L158.033 302.378Z",
    fill: "#FF9B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 287",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.3 278.539C160.3 278.539 161.495 283.862 158.753 291.512C156.011 299.163 150.255 307.106 170.637 307.106C191.018 307.106 199.24 307.106 199.24 307.106C199.24 307.106 199.889 301.91 201.547 300.271C201.547 300.271 181.256 288.512 181.256 284.357C181.256 280.202 181.256 275.568 181.256 275.568L160.3 278.539Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 280",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7099 205.906C78.7099 205.906 73.333 252.557 112.347 257.439L137.726 260.407V278.427C137.726 278.427 198.439 279.168 214.766 275.029C231.094 270.89 236.279 257.439 233.056 248.042C229.833 238.644 210.186 229.873 210.186 229.873C210.186 229.873 224.516 203.238 227.623 192.745C230.729 182.252 220.631 170.597 210.186 170.597C199.742 170.597 150.359 183.83 150.359 183.83L78.7099 205.906Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 292",
    d: "M111.486 206.742V206.742C113.274 231.573 135.559 249.801 160.251 246.629L203.097 241.123C209.443 240.308 215.232 244.834 215.971 251.19V251.19C216.735 257.757 211.811 263.613 205.21 263.986L137.724 267.805",
    stroke: "#D6DCFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 279",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.599 81.1461C155.599 81.1461 136.59 82.9752 115.474 107.741C94.3581 132.508 76.1602 206.113 76.1602 206.113C76.1602 206.113 94.0605 216.426 120.609 209.668C147.158 202.91 155.599 183.341 155.599 183.341C155.599 183.341 189.162 125.124 190.691 113.517C192.221 101.91 192.979 92.8093 182.213 88.1633C171.446 83.5173 155.599 81.1461 155.599 81.1461Z",
    fill: "#FF9B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 277",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.46 74.4557C165.46 74.4557 145.272 51.0319 146.642 40.7786C148.012 30.5253 156.008 29.5851 156.008 29.5851C156.008 29.5851 160.129 14.9168 174.981 18.0164C189.834 21.116 204.503 19.2915 205.944 24.4383C207.385 29.5851 201.247 29.5851 201.247 29.5851C201.247 29.5851 209.131 35.5916 202.759 40.7786C199.969 43.049 194.638 50.8866 184.792 59.8537C179.642 64.5444 165.46 74.4557 165.46 74.4557Z",
    fill: "#1D70D3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 273"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.021 138.589C396.021 138.589 395.04 160.222 384.636 162.037C374.232 163.851 337.117 162.037 337.117 162.037C337.117 162.037 326.338 160.701 323.055 158.386C319.772 156.071 322.407 156.147 328.557 156.147C334.706 156.147 337.117 156.147 337.117 156.147C337.117 156.147 331.205 151.741 334.985 150.766C338.765 149.792 341.066 154.387 343.7 155.267C346.333 156.147 382.883 147.367 382.883 147.367V138.589",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.021 138.589C396.021 138.589 395.04 160.222 384.636 162.037C374.232 163.851 337.117 162.037 337.117 162.037C337.117 162.037 326.338 160.701 323.055 158.386C319.772 156.071 322.407 156.147 328.557 156.147C334.706 156.147 337.117 156.147 337.117 156.147C337.117 156.147 331.205 151.741 334.985 150.766C338.765 149.792 341.066 154.387 343.7 155.267C346.333 156.147 382.883 147.367 382.883 147.367V138.589",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 275",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.005 35.7142C200.005 35.7142 204.271 42.0548 204.271 46.8491C204.271 51.6433 204.789 55.025 206.163 57.9898C207.537 60.9546 209.057 63.3777 208.797 64.2253C208.537 65.0728 205.411 65.6214 205.411 65.6214C205.411 65.6214 207.911 75.1199 206.163 78.4492C204.416 81.7785 195.827 81.9199 186.114 80.1846C183.79 84.9736 182.231 90.1921 182.231 90.1921C182.231 90.1921 185.505 107.99 175.83 109.219C166.154 110.448 162.243 83.8429 155.6 81.1461C161.586 75.7289 174.633 64.2253 174.633 64.2253C174.633 64.2253 169.446 53.0018 175.83 53.0018C182.213 53.0018 178.347 60.5785 182.231 60.5785V45.4655C182.231 45.4655 186.114 45.1919 186.114 37.4932C194.236 37.9159 200.005 35.7142 200.005 35.7142Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 276",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.848 57.9941C182.848 57.9941 184.101 66.28 186.034 66.28C187.967 66.28 191.566 66.28 192.489 69.3932C193.412 72.5064 196.227 71.106 197.217 68.2399C198.207 65.3738 205.411 65.6215 205.411 65.6215C205.411 65.6215 212.036 83.0913 205.411 84.1615C198.787 85.2317 188.72 83.8402 186.034 80.3946C183.349 76.9491 179.426 57.9941 179.426 57.9941H182.848Z",
    fill: "#1D70D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 278",
    d: "M174.955 57.3635L178.267 61.2808",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 281",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.768 93.741L217.379 129.641L195.591 150.326L174.461 133.222L188.768 93.741Z",
    fill: "#FF9B6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 283"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.779 116.382L288.911 110.446C288.911 110.446 296.562 108.057 299.427 106.354C302.293 104.651 299.427 103.837 291.103 105.321C282.779 106.806 277.627 110.446 277.627 110.446",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.779 116.382L288.911 110.446C288.911 110.446 296.562 108.057 299.427 106.354C302.293 104.651 299.427 103.837 291.103 105.321C282.779 106.806 277.627 110.446 277.627 110.446",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 294"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.823 146.468L170.122 153.5L223.765 111.897L226.317 93.0673C226.558 91.2931 228.309 90.1394 230.034 90.6186C231.072 90.9069 231.87 91.7375 232.118 92.7859L233.964 100.61C233.964 100.61 241.404 100.071 242.828 100.61C244.253 101.15 244.356 102.145 244.356 104.546C245.917 106.395 245.452 108.951 244.356 110.464C244.39 110.736 245.518 113.585 244.356 115.382C245.282 116.72 245.166 118.423 242.828 119.998C240.49 121.573 231.717 123.466 231.717 123.466L184.535 176.936C181.237 180.673 176.714 183.111 171.78 183.811C162.27 185.161 153.062 179.866 149.445 170.969L143.854 157.213",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.823 146.468L170.122 153.5L223.765 111.897L226.317 93.0673C226.558 91.2931 228.309 90.1394 230.034 90.6186V90.6186C231.072 90.9069 231.87 91.7375 232.118 92.7859L233.964 100.61C233.964 100.61 241.404 100.071 242.828 100.61C244.253 101.15 244.356 102.145 244.356 104.546C245.917 106.395 245.452 108.951 244.356 110.464C244.39 110.736 245.518 113.585 244.356 115.382C245.282 116.72 245.166 118.423 242.828 119.998C240.49 121.573 231.717 123.466 231.717 123.466L184.535 176.936C181.237 180.673 176.714 183.111 171.78 183.811V183.811C162.27 185.161 153.062 179.866 149.445 170.969L143.854 157.213",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 228",
    d: "M170.121 153.5L166.822 161.986",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 284",
    d: "M151.506 101.91C151.506 101.91 165.599 139.305 168.455 145.036L140.698 158.949C140.698 158.949 125.183 126.411 123.027 117.815",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 289",
    d: "M137.727 260.407L195.923 252.472",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 293",
    d: "M168.453 212.343L202.6 187.324C204.797 185.715 207.738 185.557 210.094 186.922V186.922C213.392 188.832 214.502 193.063 212.566 196.346L195.921 224.568",
    stroke: "#D6DCFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 290",
    d: "M210.185 229.873L148.438 204.069",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 291",
    d: "M179.312 216.972L199.241 196.513",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 295",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.198 69.8934L206.217 74.4556C206.217 74.4556 200.792 73.5356 199.24 71.2544L205.198 69.8934Z",
    fill: "white",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingParentSolution);
export default __webpack_public_path__ + "static/media/OnboardingParentSolution.883f28fb579e7b3a39467d5fbff6043d.svg";
export { ForwardRef as ReactComponent };